import React from 'react';

interface ModalBackdropProps {
  children: React.ReactNode;
}

export default function ModalBackdrop({ children }: ModalBackdropProps) {
  return (
    <div
      className={`fixed left-0 top-0 z-40 h-[100vh] w-[100vw] content-center backdrop-blur-md`}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
    >
      {children}
    </div>
  );
}
